import Vue from 'vue'
import VueRouter from 'vue-router'
import Raiz from '@/views/raiz.vue'
import Principal from '@/views/principal.vista.vue'
import Precios from '@/views/Precios/Precios.vue'
import Administracion from '@/views/Administracion/Administracion.vue';
import AdministracionInicio from '@/views/Administracion/AdministracionInicio.vue'
import Sitios from '@/views/Administracion/Sitios/Sitios.vue'
import Sitio from '@/views/Administracion/Sitios/Sitio.vue'
import Sitio_Constructor from '@/views/Administracion/Sitios/Constructor/Constructor.vue'
import Dominios from '@/views/Administracion/Dominios/Dominios.vue'
import Dominio from '@/views/Administracion/Dominios/Dominio.vue'
import Dominio_Constructor from '@/views/Administracion/Dominios/Constructor/Constructor.vue'
import AdministracionArchivos from '@/views/Administracion/Archivos/Archivos.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
		component: Raiz,
		children: [
			{
				path: '',
				component: Principal
			},
			{
				path: '/precios',
				component: Precios
			}
		]
	},
  {
    path: '/administración',
		component: Administracion,
		children: [
			{
				path: '',
				component: AdministracionInicio
			},
			{
				path: 'sitios',
				component: Sitios
			},
			{
				path: 'sitios/:sitio',
				component: Sitio,
			},
			{
				path: 'sitios/:sitio/constructor',
				component: Sitio_Constructor,
			},
			{
				path: 'dominios',
				component: Dominios,
			},
			{
				path: 'dominios/:dominio',
				component: Dominio,
			},
			{
				path: 'dominios/:dominio/constructor',
				component: Dominio_Constructor
			},
			{
				path: 'archivos',
				component: AdministracionArchivos,
			},
		]
	},
	
  //{
  //  path: '/about',
  //  name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
  //  component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  //}
]

const router = new VueRouter({
	mode: 'history',
  routes
})

export default router
